document.addEventListener('DOMContentLoaded', function() {
  // Alle Kategoriebeschreibungen finden
  const descriptions = document.querySelectorAll('.category-description');
  
  descriptions.forEach(function(description) {
    const content = description.querySelector('.description-content');
    
    if (!content) return;
    
    const fullHTML = content.innerHTML.trim();
    
    // HTML in "Sätze" aufteilen (nach schließenden Tags von p, h1, h2, etc.)
    const htmlParts = fullHTML.split(/(<\/(?:p|h[1-6]|div|li)>)/i);
    
    let sentences = [];
    let currentSentence = '';
    
    for (let i = 0; i < htmlParts.length; i++) {
      currentSentence += htmlParts[i];
      // Wenn wir einen schließenden Tag finden, ist das ein "Satz"
      if (htmlParts[i].match(/<\/(?:p|h[1-6]|div|li)>/i)) {
        sentences.push(currentSentence);
        currentSentence = '';
      }
    }
    
    // Falls noch Text übrig ist
    if (currentSentence.trim()) {
      sentences.push(currentSentence);
    }
    
    // Erste 3 "Sätze" (HTML-Blöcke) für Kurzversion
    const shortHTML = sentences.slice(0, 3).join('');
    
    // Nur "Mehr zeigen" Button hinzufügen, wenn mehr als 3 HTML-Blöcke
    if (sentences.length > 3) {
      // Eindeutige ID für Accessibility generieren
      const uniqueId = 'description-content-' + Math.random().toString(36).substr(2, 9);
      
      content.innerHTML = `
        <div class="short-text" id="${uniqueId}-short">${shortHTML}</div>
        <div class="full-text" id="${uniqueId}-full" style="display: none;">${fullHTML}</div>
        <button class="toggle-btn" 
                data-expanded="false" 
                aria-expanded="false"
                aria-controls="${uniqueId}-full ${uniqueId}-short"
                aria-label="Vollständige Beschreibung anzeigen">
          Mehr zeigen
        </button>
      `;
      
      // Event Listener für Toggle-Button
      const toggleBtn = content.querySelector('.toggle-btn');
      const shortTextDiv = content.querySelector('.short-text');
      const fullTextDiv = content.querySelector('.full-text');
      
      toggleBtn.addEventListener('click', function() {
        const isExpanded = this.getAttribute('data-expanded') === 'true';
        
        if (isExpanded) {
          // Zu Kurzversion wechseln
          shortTextDiv.style.display = 'block';
          fullTextDiv.style.display = 'none';
          this.textContent = 'Mehr zeigen';
          this.setAttribute('data-expanded', 'false');
          this.setAttribute('aria-expanded', 'false');
          this.setAttribute('aria-label', 'Vollständige Beschreibung anzeigen');
        } else {
          // Zu Vollversion wechseln
          shortTextDiv.style.display = 'none';
          fullTextDiv.style.display = 'block';
          this.textContent = 'Weniger zeigen';
          this.setAttribute('data-expanded', 'true');
          this.setAttribute('aria-expanded', 'true');
          this.setAttribute('aria-label', 'Beschreibung verkürzen');
        }
      });
    }
  });
});